import { z } from "zod";

export const planSchema = () => {
  return z.object({
    name: z.string().min(1),
    agreement: z.number().min(1),
    plan_types: z.array(z.string()).optional().nullable(),
    target: z.string().optional().nullable(),
    level: z.number().min(1).optional().nullable(),
    access_amount: z.any().refine((val) => {
      if (typeof val !== "undefined") {
        return true;
      } else return false;
    }),
    value: z.string().optional().nullable(),
    vindi_page: z.string().optional().nullable(),
    vindi_token: z.string().optional().nullable(),
    slug: z.string().optional().nullable(),
    audiobook_quantity: z.any().refine((val) => {
      if (typeof val !== "undefined") {
        return true;
      } else return false;
    }),
    book_quantity: z.any().refine((val) => {
      if (typeof val !== "undefined") {
        return true;
      }
      return false;
    }),
    magazine_quantity: z.any().refine((val) => {
      if (typeof val !== "undefined") {
        return true;
      }
      return false;
    }),
    default: z.boolean().optional(),
  });
};

export type PlanFormValues = z.infer<ReturnType<typeof planSchema>>;
